import { Button, TextField, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogForm, DialogTitle } from '~/components/dialogs/components';
import { DialogActions, DialogContent } from '~/components/dialogs/lib';
import { formatDate } from '~/lib/datetime';
import type { NetworkAuditLogs__AuditLog as AuditLog } from '../queries/list.generated';

export interface DetailsDialogProps {
  open: boolean;
  onClose: () => void;
  row: AuditLog | null;
}

export const DetailsDialog = ({ open, onClose, row }: DetailsDialogProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return row ? (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle onClose={onClose}>{t('pages.audit_logs.details_dialog.title')}</DialogTitle>
      <DialogContent>
        <DialogForm>
          <label>
            <span className={`label`}>{t('components.audit_logs.misc.date_time')}</span>
            <TextField value={formatDate(row.createdAt)} disabled fullWidth />
          </label>
          <label>
            <span className={`label`}>{t('components.audit_logs.misc.user')}</span>
            <TextField value={row.userName} disabled fullWidth />
          </label>
          <label>
            <span className={`label`}>{t('common.labels.action')}</span>
            <TextField value={row.actionName} disabled fullWidth />
          </label>
          <label>
            <span className={`label`}>{t('common.labels.details')}</span>
            <pre
              style={{
                backgroundColor: theme.palette.background.default,
                border: `1px solid ${theme.palette.borders.light}`,
                borderRadius: '4px',
                color: theme.palette.text.primary,
                fontSize: '.9em',
                width: '100%',
                padding: '8px',
              }}
            >
              {JSON.stringify(row.payload || {}, null, 2)}
            </pre>
          </label>
        </DialogForm>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t('common.actions.close')}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};
